import { useEffect, useState } from 'react';
import releaseNoteApi from '../../services/releaseNoteApi';
import { getLastSeen, isUnread, SEEN_EVENT } from './release-notes-seen';

// The sidebar's "New" dot (spec §6): one cheap probe per mount (and per
// token change) for the newest published note, compared with the last one
// this browser opened the feed or a permalink with. `available` is false only
// when the route itself is missing (404: the dashboard shipped before
// thisway-api PR #192); any other failure leaves both entries in place.
const useReleaseNotesUnread = (token) => {
  const [newest, setNewest] = useState(null);
  const [available, setAvailable] = useState(true);
  const [lastSeen, setLastSeen] = useState(() => getLastSeen());

  useEffect(() => {
    let cancelled = false;
    releaseNoteApi
      .list('?pageNumber=1&pageSize=1')
      .then((res) => {
        if (cancelled) return;
        setAvailable(true);
        setNewest(res.data?.data?.[0]?.publishedat || null);
      })
      .catch((err) => {
        if (!cancelled && err?.response?.status === 404) setAvailable(false);
      });
    const onSeen = () => setLastSeen(getLastSeen());
    window.addEventListener(SEEN_EVENT, onSeen);
    return () => {
      cancelled = true;
      window.removeEventListener(SEEN_EVENT, onSeen);
    };
  }, [token]);

  return { unread: isUnread(newest, lastSeen), available };
};

export default useReleaseNotesUnread;
